/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Account_ChangedInputs */

const en_google_drive_account_changed = /** @type {(inputs: Google_Drive_Account_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Google Drive account changed. Refresh to see its files.`)
};

const es_google_drive_account_changed = /** @type {(inputs: Google_Drive_Account_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cuenta de Google Drive ha cambiado. Actualiza para ver sus archivos.`)
};

/**
* | output |
* | --- |
* | "The Google Drive account changed. Refresh to see its files." |
*
* @param {Google_Drive_Account_ChangedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_account_changed = /** @type {((inputs?: Google_Drive_Account_ChangedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Account_ChangedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_account_changed(inputs)
	return en_google_drive_account_changed(inputs)
});